import React, { Component } from 'react';

import { postJson } from '../../helpers/RequestsHelper'
import { withTranslation } from 'react-i18next';

class APIKeysInput extends Component {

    state = {
        apiToken: "",
        apiId: undefined
    }
    constructor() {
        super()

        this.handleAPITokenChange = this.handleAPITokenChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleAPITokenChange(event) {
        this.setState({ apiToken: event.target.value });
    }

    handleSubmit = async (event) => {
        try {
            if (this.state.apiToken.length > 0) {
                await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/" + this.props.accountType + "/token?accountId=" + (this.props.accountId ? this.props.accountId : this.props.accountType + "&new=1"), { apiToken: this.state.apiToken, name: this.state.name, apiId: this.state.apiId })
                this.setState({})
                //TODO: Can we do that without reload?
                window.location.reload()
            } else {
                this.setState({ error: true })
            }
        } catch {
            this.setState({ error: true })
        }
    }

    render() {
        //TODO: Localize
        const { t } = this.props;
        return (
            <>
                {t("desc_" + this.props.accountType + "_apikey")}
                <input type="text" className="form-control" value={this.state.apiToken} onChange={this.handleAPITokenChange} required={true} />
                <label>
                    {t("desc_" + this.props.accountType + "_name")}
                    <input type="text" className="form-control" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} required={true} />
                </label>
                <br />
                {this.props.hasAPIId ?
                    <>
                        <label>
                            {t("desc_" + this.props.accountType + "_apiId")}
                            <input type="text" className="form-control" value={this.state.apiId} onChange={(e) => this.setState({ apiId: e.target.value })} required={true} />
                        </label>

                        <br />
                    </>
                    : <></>}
                {this.state.error ? <small id="errorMessage" className="text-danger">Please fill all fields<br /></small> : ""}
                <input type="button" className="submit-btn" value={t("btncontinue")} onClick={this.handleSubmit} />
            </>
        )
    }
}

export default withTranslation()(APIKeysInput)